'use client';
import React, { createContext, Dispatch } from 'react';

interface AffiliateContextProps {
  aff_id: string;
  setAffiliateId: Dispatch<string>;
}

const defaultAffiliateContext: AffiliateContextProps = {
  aff_id: '',
  setAffiliateId: (_aff_id: string) => undefined,
};
const AffiliateContext = createContext(defaultAffiliateContext);
const AffiliateProvider = ({ children }) => {
  const [aff_id, setAffId] = React.useState<string>('');

  const setAffiliateId = (aff_id: string) => {
    setAffId(aff_id);
  };
  const values = {
    aff_id,
    setAffiliateId,
  };
  return <AffiliateContext.Provider value={values}>{children}</AffiliateContext.Provider>;
};
export { AffiliateContext, AffiliateProvider };
